import { combineReducers } from '@reduxjs/toolkit'

import { calcReducer } from '../calc'
import { companiesReducer } from '../companies'
import { contextMenuItemsReducer } from '../contextMenu'
import { correlationSchemeWellsIdsReducer } from '../correlationSchemeWellsIds'
import { cubeLineForTabReducer } from '../cubeLinesForTabs'
import { cubeReducer } from '../cubes'
import { domainTypesReducer } from '../domainTypes'
import { faultsReducer } from '../faults'
import { fieldsReducer } from '../fields'
import { hotStorageReducer } from '../hotStorage'
import { mapFetchingReducer } from '../mapFetching'
import { mapsReducer } from '../maps'
import { markersReducer } from '../markers'
import { uploadMultipartFilesReducer } from '../multipartUploads'
import { overallSearchReducer } from '../overallSearch'
import { projectReducer } from '../project'
import { projectsReducer } from '../projects'
import { projectTypesReducer } from '../projectTypes'
import { signalRReducer } from '../signalR'
import { survey2dReducer } from '../surveys2ds'
import { treeReducer } from '../tree'
import { treeObjectsReducer } from '../treeObjects'
import { tabElementPropertiesReducer } from '../treeTabElementProperties'
import { uploadsReducer } from '../uploads'
import { userReducer } from '../user'
import { velocityAllowedTypesReducer } from '../velocityAllowedTypes'
import { velocityDomainsReducer } from '../velocityDomain'
import { velocityModelsReducer } from '../velocityModels'
import { velocitySimulationsReducer } from '../velocitySimulation'
import { vspReducer } from '../vsp'
import { workAreaReducer } from '../workArea'

export const rootReducer = combineReducers({
  companies: companiesReducer,
  fields: fieldsReducer,
  project: projectReducer,
  projects: projectsReducer,
  projectTypes: projectTypesReducer,
  markers: markersReducer,
  cubeLinesForTabs: cubeLineForTabReducer,
  cubes: cubeReducer,
  faults: faultsReducer,
  surveys2ds: survey2dReducer,
  domainTypes: domainTypesReducer,
  uploads: uploadsReducer,
  workAreas: workAreaReducer,
  maps: mapsReducer,
  mapFetching: mapFetchingReducer,
  signalR: signalRReducer,
  tree: treeReducer,
  treeObjects: treeObjectsReducer,
  tabElementProperties: tabElementPropertiesReducer,
  contextMenu: contextMenuItemsReducer,
  velocitySimulations: velocitySimulationsReducer,
  velocityDomains: velocityDomainsReducer,
  velocityModels: velocityModelsReducer,
  velocityAllowedTypes: velocityAllowedTypesReducer,
  uploadMultipartFiles: uploadMultipartFilesReducer,
  correlationSchemeWellsIds: correlationSchemeWellsIdsReducer,
  userInfo: userReducer,
  overallSearch: overallSearchReducer,
  surfaceCalc: calcReducer,
  wellVsp: vspReducer,
  hotStorage: hotStorageReducer,
})
